

































































import {Component, Vue} from 'vue-property-decorator';
import {genListOfYears} from '@/modules/budget/budgetCorrectHelper';

interface IVariant {
    id: number;
    variant_uuid: string;
    name_ru: string;
    year: number;
    region_code: string;
}

interface IAbpBase {
    abp: number;
    name_ru: string;
    name_kk?: string;
}

@Component
export default class BudgetFilesDownload extends Vue {

    private selectedYear: number | null = null;
    private selectedVariant: string | null = null;
    private selectedAbp: number | null = null;

    private variants: IVariant[] = [];
    private abpList: IAbpBase[] = [];

    private loadingVariants = false;
    private loadingAbp = false;
    private downloading = false;

    private get listOfYears() {
        return genListOfYears();
    }

    private get usrId(): string {
        return this.$store.getters.user_uuid;
    }

    private get variantOptions(): IVariant[] {
        if (!this.selectedYear) return [];
        return this.variants.filter(v => v.year == this.selectedYear);
    }

    private get isReady(): boolean {
        return !!this.selectedYear && !!this.selectedVariant && !!this.selectedAbp;
    }

    private async onYearChange(): Promise<void> {
        this.selectedVariant = null;
        this.selectedAbp = null;
        this.variants = [];
        this.abpList = [];

        if (!this.selectedYear) return;

        await Promise.all([
            this.loadVariants(),
            this.loadAbp()
        ]);
    }

    private async loadVariants(): Promise<void> {
        this.loadingVariants = true;
        try {
            const response = await fetch('/api-py/get-variants');
            if (response.ok) {
                const all: IVariant[] = await response.json();
                this.variants = all
                    .filter(v => v.year == this.selectedYear)
                    .sort((a, b) => a.id - b.id);
            } else {
                this.makeToast('danger', `Ошибка загрузки вариантов: ${response.status}`, 'Ошибка');
            }
        } catch (e) {
            this.makeToast('danger', 'Ошибка загрузки вариантов: ' + (e as Error).toString(), 'Ошибка');
        } finally {
            this.loadingVariants = false;
        }
    }

    private async loadAbp(): Promise<void> {
        if (!this.usrId || !this.selectedYear) return;
        this.loadingAbp = true;
        try {
            const response = await fetch(`/api-py/get-abp-by-user-id/${this.usrId}/${this.selectedYear}`);
            if (response.ok) {
                const result: IAbpBase[] = await response.json();
                this.abpList = [...new Map(result.map(a => [a.abp, a])).values()];
            } else {
                this.makeToast('danger', `Ошибка загрузки АБП: ${response.status}`, 'Ошибка');
            }
        } catch (e) {
            this.makeToast('danger', 'Ошибка загрузки АБП: ' + (e as Error).toString(), 'Ошибка');
        } finally {
            this.loadingAbp = false;
        }
    }

    private async downloadFiles(): Promise<void> {
        if (!this.isReady) return;
        this.downloading = true;
        try {
            const params = new URLSearchParams({
                year: String(this.selectedYear),
                abpCode: String(this.selectedAbp),
                variant: this.selectedVariant!
            });

            const response = await fetch(`/api-py/download-filtered-files?${params}`);

            if (response.status === 404) {
                this.makeToast('warning', 'Файлы не найдены для выбранных параметров', 'Выгрузка');
                return;
            }
            if (!response.ok) {
                this.makeToast('danger', `Ошибка сервера: ${response.status}`, 'Ошибка');
                return;
            }

            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `files_${this.selectedAbp}_${this.selectedYear}.zip`;
            link.click();
            URL.revokeObjectURL(link.href);

            this.makeToast('success', 'Архив успешно скачан', 'Выгрузка');
        } catch (e) {
            this.makeToast('danger', 'Сетевая ошибка: ' + (e as Error).toString(), 'Ошибка');
        } finally {
            this.downloading = false;
        }
    }

    private makeToast(variant: string, body: string, title: string): void {
        this.$bvToast.toast(body, {title, variant, autoHideDelay: 4000, solid: true});
    }
}
